import React from 'react';

import TopPage from 'v2/components/Shared/TopPage';

import TransfersTable from './TransfersTable';

function TransferHistory() {
  return (
    <div className='font-sans'>
      <TopPage
        title='Histórico de Transferências'
        extra='Veja todas as transferências feitas para a sua conta.'
        goBackTo='/producer/financial-statement'
      />
      <TransfersTable />
    </div>
  );
}

export default TransferHistory;
